import React from 'react';
import { addZeroToDigit } from '../helper/TimerHelpers';
import { generalSessionTimerConstants } from '../constants/generalConstants';
import { Text } from '../../textVariations';
import { SessionTimerTypes } from '../SessionTimerTypes';

export const ResponsiveSessionTimer = ({
  minutes,
  seconds,
}: SessionTimerTypes.TResponsiveSessionTimer) => {
  const { sessionTimerHeading, minutesLabel } = generalSessionTimerConstants;

  return (
    <div className="responsiveSessionTimerParentComponent">
      <Text renderAs={'p'} className="timerLabel">
        {sessionTimerHeading}:
      </Text>
      <span className="timer">
        {addZeroToDigit(minutes)} : {addZeroToDigit(seconds)}
      </span>
      <span className="timerUnitLabel">{minutesLabel}</span>
    </div>
  );
};
